﻿import DefaultApp from './defaultApp';

import NewsItem from './components/NewsItem.vue';

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
import { swiperConfig } from '../vendor/swiper';

const newsApp = {
    ...DefaultApp,
    components: {
        ...DefaultApp.components,
        NewsItem,
    },
    data() {
        return {
            ...DefaultApp.data(),
            dataTopicLabel: '',
            dataResearcherLabel: '',

            swiper: null,
            isForMedia: false,
        }
    },
    computed: {
        ...DefaultApp.computed,
        filterItems() {
            if (this.dataOverruleIds.length && !this.itemsSet) {
                return [
                    {
                        Key: this.constants.filterAliases.id,
                        Values: this.dataOverruleIds,
                        Operator: this.constants.operators.in,
                    }
                ]
            }
            let tempFilterArray = this.data.facets.filter(facet => facet.values.length && facet.inputType === this.constants.inputTypes.select).map(facet => {
                let values = facet.values.filter(option => option && option.valueAlias).map(option => option.valueAlias);
                return {
                    Key: facet.alias,
                    Values: values,
                    Operator: this.constants.operators.in,
                }
            });
            if (this.isForMedia) {
                tempFilterArray.push({
                    Key: this.constants.keys.isForMedia,
                    Values: ['true'],
                    Operator: this.constants.operators.in,
                })
            }
            if (this.ownId) {
                tempFilterArray.push({
                    Key: this.constants.keys.id,
                    Values: [this.ownId],
                    Operator: this.constants.operators.notIn,
                })
            }
            return tempFilterArray;
        },
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;

            if (this.$el.dataset.widget) this.dataWidget = this.$el.dataset.widget;
            if (this.$el.dataset.sidebar) this.dataSidebar = this.$el.dataset.sidebar;
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.ownid) this.ownId = this.$el.dataset.ownid;
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.topiclabel) this.dataTopicLabel = this.$el.dataset.topiclabel;
            if (this.$el.dataset.researcherlabel) this.dataResearcherLabel = this.$el.dataset.researcherlabel;
            if (this.$el.dataset.isformedia) this.isForMedia = true;

            const urlParams = new URLSearchParams(window.location.search);
            if (this.$el.dataset.topics) {
                urlParams.set(this.constants.filterTitles.topics, this.$el.dataset.topics);
            }

            let pageParam = urlParams.has(this.constants.queryParams.page) ? parseInt(urlParams.get(this.constants.queryParams.page)) : 0;
            if (pageParam) urlParams.delete(this.constants.queryParams.page);
            let filterParams = urlParams.toString() ? urlParams : null;
            if (filterParams) {
                const facetsResponse = await this.fetchData();
                this.setFacets(facetsResponse);
                this.setFacetValuesFromUrl();
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (overruleResponse && overruleResponse.data && overruleResponse.data.items && overruleResponse.data.items.length) {
                    overruleResponse.data.items = overruleResponse.data.items.sort((a, b) => this.dataOverruleIds.indexOf(a.id) - this.dataOverruleIds.indexOf(b.id));
                }
                this.setData(overruleResponse, true);
                this.dataOverruleIds = [];
            }

            let tempLimit = this.dataLimit;
            if (pageParam && !this.dataWidget) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit + (this.dataLimit * this.page);
            } 

            const response = await this.fetchData();
            let replace = !this.itemsSet;
            this.setData(response, replace);
            this.dataLimit = tempLimit;

            if (this.dataSidebar && (this.data.items.length < this.dataLimit)) {
                const blankResponse = await this.fetchDataBlank();
                this.setData(blankResponse, false);
            }

            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }

            this.loading = false;
        },
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets.sort((a, b) => a.sortOrder - b.sortOrder).map(facet => {
                let label = facet.alias;
                switch (facet.alias) {
                    case this.constants.filterAliases.topics:
                        label = this.dataTopicLabel;
                        break;
                    case this.constants.filterAliases.researchers:
                        label = this.dataResearcherLabel;
                        break;
                    default:
                        break;
                }

                return {
                    ...facet,
                    values: facet.options.filter(option => option.selected),
                    label: label,
                }
            });
            this.data.queryCount = response.data.queryCount;
            if (this.dataSidebar) this.setFacetValuesFromUrl();
        },
        updateUrl() {
            if (!this.queryModel.FilterItems.length && !this.page) {
                history.pushState({}, null, window.location.pathname);
                window.dispatchEvent(new CustomEvent('update-url'));
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => {
                    let facet = this.data.facets.find(facet => facet.alias === filterItem.Key);
                    urlParams.set(facet.title, filterItem.Values.join());
                });
            }
            if (this.page) urlParams.set(this.constants.queryParams.page, this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
            window.dispatchEvent(new CustomEvent('update-url'));
        },
        initSwiper() {
            this.swiper = new Swiper(this.$refs.swiper, {
                ...swiperConfig,
                spaceBetween: 48,
            });
        }
    },
    updated() {
        if (this.dataWidget && !this.dataSidebar) this.initSwiper();
    },
};

export default newsApp;
